import URLSearchParams from 'url-search-params';

export const getQueryString = ({location: { search }}) => 
  new URLSearchParams(search);

export default getQueryString;
